import { AfterViewInit, Directive, ElementRef, inject, Input } from "@angular/core";
import { CerrixInputValidationErrorsDirective } from "./cerrix-input-validation-errors.directive";
import { CerrixInputValidation } from "./models/cerrix-input-validation.interface";

@Directive({
    selector: "[appValidationIsUrlField]",
    host: {
        "(input)": "onInput()",
        "(focusout)": "onInput()",
    },
})
export class CerrixInputValidationIsUrlDirective implements CerrixInputValidation, AfterViewInit {
    @Input() validationUrlKey = "url";
    @Input() validationUrlMessage: string | null = null;
    @Input() validationUrlPriority = 10;

    private inputElement!: HTMLInputElement | HTMLTextAreaElement;

    private elRef: ElementRef<HTMLElement> = inject(ElementRef<HTMLElement>);
    private errors: CerrixInputValidationErrorsDirective | null = inject(
        CerrixInputValidationErrorsDirective,
        { optional: true },
    );

    ngAfterViewInit() {
        this.inputElement = this.findInputElement();
        this.errors.register(this);
    }

    private findInputElement(): HTMLInputElement | HTMLTextAreaElement {
        const native = this.elRef.nativeElement;
        if (native instanceof HTMLInputElement || native instanceof HTMLTextAreaElement) {
            return native;
        }
        return native.querySelector("input, textarea") as HTMLInputElement | HTMLTextAreaElement;
    }

    onInput() {
        this.validate();
    }

    validate() {
        if (!this.inputElement) return;

        const value = this.inputElement.value;
        if (value.length === 0) {
            this.errors?.remove(this.validationUrlKey);
            return;
        }

        const hyperlinkRegex = new RegExp(/^(https?:\/\/)?([a-z0-9-]+\.)+[a-z]{2,6}(\/[^\s]*)?$/i);

        const isUrl = hyperlinkRegex.test(value);

        if (!isUrl) {
            this.errors?.add({
                key: this.validationUrlKey,
                message: this.validationUrlMessage ?? `Input must be a valid URL.`,
                priority: this.validationUrlPriority,
            });
        } else {
            this.errors?.remove(this.validationUrlKey);
        }
    }
}
